/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface HoursOfOperationProps {
  is24Hours: boolean | null;
  startTime: Date | null;
  endTime: Date | null;
}

export class HoursOfOperationRecord extends Record<HoursOfOperationProps>({
  is24Hours: null as any,
  startTime: null as any,
  endTime: null as any,
}) {
  public static fromJS(json: {
    is24Hours: boolean | null;
    startTime: string | number | Date | null;
    endTime: string | number | Date | null;
  }): HoursOfOperationRecord {
    if (json == null) {
      throw new Error('HoursOfOperationRecord.fromJS: parameter cannot be null');
    }
    return new HoursOfOperationRecord({
      is24Hours: json.is24Hours,
      startTime: json.startTime != null ? new Date(json.startTime) : null,
      endTime: json.endTime != null ? new Date(json.endTime) : null,
    });
  }

  public static fromJSUnsafe(json: {
    is24Hours: boolean | null;
    startTime: string | number | Date | null;
    endTime: string | number | Date | null;
  }): [HoursOfOperationRecord, Error[]] {
    if (json == null) {
      throw new Error('HoursOfOperationRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new HoursOfOperationRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      is24Hours: tryOrDefault(
        () => json.is24Hours,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      startTime: tryOrDefault(
        () => (json.startTime != null ? new Date(json.startTime) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      endTime: tryOrDefault(
        () => (json.endTime != null ? new Date(json.endTime) : null),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: HoursOfOperationProps) {
    super(props);
    if (props == null) {
      throw new Error('HoursOfOperationRecord constructor parameter cannot be null');
    }
  }
}

export abstract class HoursOfOperationViewModelBase implements HoursOfOperationProps {
  protected readonly _props: HoursOfOperationProps;
  private _json?: HoursOfOperationProps;

  get is24Hours(): boolean | null {
    return this._props.is24Hours;
  }
  get startTime(): Date | null {
    return this._props.startTime;
  }
  get endTime(): Date | null {
    return this._props.endTime;
  }

  constructor(props: HoursOfOperationProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        is24Hours: this._props.is24Hours,
        startTime: this._props.startTime,
        endTime: this._props.endTime,
      };
    }
    return this._json;
  }
}
